module.exports = __webpack_public_path__ + "static/media/plus-circle-icon.61b5f6e0.svg";